// EU AI Act application dates, as they actually stand.
//
// Source: Regulation (EU) 2024/1689 (the AI Act), as amended by
// Regulation (EU) 2026/1744 (the "Digital Omnibus on AI"), published in
// the Official Journal on 24 July 2026 and in force since 27 July 2026.
//
// The omnibus deferred the Chapter III high-risk regime but left the
// Article 50 transparency duties on their original date. That split is
// the whole point of this module: a customer-facing banking assistant is
// bound by Article 50 today, and by Chapter III only if its scope reaches
// an Annex III use case (for banks, creditworthiness under Annex III 5(b)).

export const AI_ACT_DATES = {
  // Art. 5 prohibitions and Art. 4 AI literacy.
  prohibitionsAndLiteracy: Date.UTC(2025, 1, 2), // 2 Feb 2025
  // GPAI model obligations, governance, penalties.
  gpaiAndGovernance: Date.UTC(2025, 7, 2), // 2 Aug 2025
  // Art. 50 transparency. Not deferred by the omnibus.
  transparency: Date.UTC(2026, 7, 2), // 2 Aug 2026
  // Art. 50(2) marking, for systems on the market before 2 Aug 2026.
  // Also the new Art. 5 NCII/CSAM prohibitions.
  markingGraceEnds: Date.UTC(2026, 11, 2), // 2 Dec 2026
  // Chapter III high-risk, Annex III. Was 2 Aug 2026.
  highRiskAnnexIII: Date.UTC(2027, 11, 2), // 2 Dec 2027
  // Chapter III high-risk, Annex I. Was 2 Aug 2027.
  highRiskAnnexI: Date.UTC(2028, 7, 2), // 2 Aug 2028
};

export const hasApplied = (date, now = Date.now()) => now >= date;

export const isTransparencyInForce = (now = Date.now()) =>
  hasApplied(AI_ACT_DATES.transparency, now);

export const monthsUntil = (date, now = Date.now()) =>
  Math.max(0, Math.round((date - now) / (1000 * 60 * 60 * 24 * 30.44)));

export const monthsUntilHighRisk = (now = Date.now()) =>
  monthsUntil(AI_ACT_DATES.highRiskAnnexIII, now);
